import React from 'react'
import Layout from '../Layout'
import ResourceForm from '../../../Components/ResourceForm'
import FormFieldController from '../../../Components/FormFieldController'
import BackLink from '../../../Components/BackLink'
import CurrentImagePreview from '../../../Components/CurrentImagePreview'
import { sponsorSchema } from '../../../schemas'

export default function Edit({ account, accounts, navigation, sponsor }) {
  return (
    <Layout
      account={account}
      accounts={accounts}
      navigation={navigation}
      title={`Edit: ${sponsor.name}`}
    >
      <BackLink href="/manage/sponsors">Back to Sponsors</BackLink>

      <div className="bg-white shadow rounded-lg">
        <ResourceForm
          schema={sponsorSchema}
          resource="sponsor"
          endpoint={`/manage/sponsors/${sponsor.id}`}
          method="patch"
          backLink="/manage/sponsors"
          submitLabel="Save Changes"
          defaultValues={{
            name: sponsor.name || '',
            url: sponsor.url || '',
            short_description: sponsor.short_description || '',
            logo: null
          }}
        >
          {({ control, errors }) => (
            <>
              <FormFieldController
                control={control}
                name="name"
                label="Name"
                required
                errors={errors}
              />

              <FormFieldController
                control={control}
                name="url"
                label="Website URL"
                type="url"
                errors={errors}
              />

              <FormFieldController
                control={control}
                name="short_description"
                label="Short Description"
                type="textarea"
                rows={2}
                errors={errors}
              />

              <CurrentImagePreview
                url={sponsor.logo_url}
                alt={sponsor.name}
                label="Current Logo"
                className="h-16 rounded-lg object-contain bg-gray-100"
              />

              <FormFieldController
                control={control}
                name="logo"
                label={sponsor.logo_url ? "Replace Logo" : "Logo"}
                type="file"
                accept="image/*"
                errors={errors}
              />
            </>
          )}
        </ResourceForm>
      </div>
    </Layout>
  )
}
